import _ from 'lodash';
export const TopNavData = (data, father, isThird = false) => {
  return data.map((v) => {
    let res = {
      label: v.name,
      key: v.catalog_id,
      path: `#/list/article/${father}/${v.catalog_id}`,
    };
    if (typeof v.has_post !== 'undefined') {
      res.has_post = v.has_post;
      res.href = `#/list/article/${father}/${v.catalog_id}`;
    }
    if (isThird) res.isThird = isThird;
    if (v.children.length > 0) {
      if (isThird) {
        // 如果是3级的话 要换个key 不然导航会有问题
        const thirdData = TopNavData(v.children, `${father}/${v.catalog_id}`, true);
        res.thirdData = thirdData;
        res.href = `#/list/article/${father}/${v.catalog_id}/${thirdData[0].key}`;
      } else {
        res.data = TopNavData(v.children, father, true);
      }
    }
    return res;
  });
};
export const FirstLevelHref = (data = [], level = 0) => {
  let result = '';
  level++;
  if (_.isEmpty(data)) return result;
  if (data[0].has_post && level === 1) {
    // 如果是第一级 并且 没有children 的情况就直接 拼上一级的id
    return `/${data[0].catalog_id}`;
  }
  if (!_.isEmpty(data[0].children)) {
    result = `/${data[0].children[0].catalog_id}${FirstLevelHref(data[0].children, level)}`;
  }
  return result;
};

export const flat = (data) => {
  let res = [];
  _.map(data, (v) => {
    if (!_.isEmpty(v.data || v.thirdData)) {
      res = [...res, ...flat(v.data || v.thirdData)];
    }
    res.push(v);
  });
  return res;
};
export const HotKeyWorkData = ['服务商申请', 'OCPA', '素材审核', '人群定向', '创意工具'];
export const HotKeyArticle = [
  { title: '【重要】附近推资料库', id: 2810 },
  { title: '销售沟通话术', id: 3001 },
  { title: '腾老师直播间培训回顾', id: 2554 },
  { title: '行业解决方案', id: 2562 },
  { title: '产品技数-OCPA', id: 2768 },
  { title: '产品技数-枫页落地页产品介绍', id: 2842 },
  { title: '行业解决方案-金融', id: 2893 },
  { title: '行业解决方案-汽车行业投手训练营', id: 2853 },
  { title: '资源-OTT全链路广告', id: 3218 },
];
